<mat-toolbar mat-dialog-title>
  <div class="dialog-title">{{ 'related_documents_tr' | translate }}</div>
  <div style="flex-grow: 1"></div>
  <button type="button" class="close-btn" mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content>
  <app-report-product-documents [documents]="documents" [preview]="preview" (documentClick)="openDocument($event)"></app-report-product-documents>
</mat-dialog-content>
